/**
 * SaveProgressDialog — Shows progress during GitHub issue creation.
 *
 * Displays a progress bar and status messages while voice comments
 * are being saved as GitHub issues.
 */

interface SaveProgressDialogProps {
  readonly open: boolean;
  readonly current: number;
  readonly total: number;
  readonly sessionName: string;
}

export function SaveProgressDialog({
  open,
  current,
  total,
  sessionName,
}: SaveProgressDialogProps) {
  if (!open) return null;

  const percent = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div
      className="fb-dialog-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Saving feedback"
    >
      <div className="fb-dialog">
        <h3 className="fb-dialog-title">Saving Feedback</h3>
        <p className="fb-dialog-message">
          Creating GitHub issues for &ldquo;{sessionName}&rdquo;&hellip;
        </p>
        <div className="fb-progress-bar-track">
          <div
            className="fb-progress-bar-fill"
            style={{ width: `${percent}%` }}
            role="progressbar"
            aria-valuenow={current}
            aria-valuemin={0}
            aria-valuemax={total}
          />
        </div>
        <p className="fb-progress-text">
          {current} of {total} issues created ({percent}%)
        </p>
      </div>
    </div>
  );
}
